module.exports = __webpack_public_path__ + "static/payal_after-d611912cb142fa2b6be109b62cd6175f.jpg";